import { API_BASE, authFetch, readJson } from "./base";
import type { ReflectProjection } from "./projection-types";

export async function getReflectProjection(): Promise<ReflectProjection> {
  const response = await authFetch(`${API_BASE}/projections/reflect`);
  return readJson<ReflectProjection>(response, "Failed to load reflect projection");
}

// ── Reflect synthesis (editorial banner) — FR-5, §4.5.1 ────────────

export interface ReflectSynthesis {
  synthesis_text: string;
  /** ISO 8601 UTC timestamp of when the synthesis was generated. */
  generated_at: string;
  /** True when a template fallback was used (low-data, timeout, banlist exhaustion). */
  fallback: boolean;
}

export async function getReflectSynthesis(): Promise<ReflectSynthesis> {
  const response = await authFetch(`${API_BASE}/projections/reflect/synthesis`);
  return readJson<ReflectSynthesis>(response, "Failed to load reflect synthesis");
}
